import protoRoot from "../proto-root";
import DataRemoteSettings from "../private/DataRemoteSettings";
import BatteryStatus from "../private/BatteryStatus";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";
import MotionDetectorState from "../private/MotionDetectorState";

function create({
  lastMotion,
  lastNoise,
  remoteSettings,
  batteryStatus,
  cameraAndFlashlightState,
  motionDetectorState
}) {
  const BabyStationState = protoRoot.lookupType(`comm.BabyStationState`);

  return BabyStationState.create({
    lastMotion,
    lastNoise,
    remoteSettings: DataRemoteSettings.create(remoteSettings),
    batteryStatus: BatteryStatus.create(batteryStatus),
    cameraAndFlashlightState: CameraAndFlashlightState.create(
      cameraAndFlashlightState
    ),
    motionDetectorState: MotionDetectorState.create(motionDetectorState)
  });
}

export default {
  create
};

// message BabyStationState {
//   int64 lastNoise = 1;
//   int64 lastMotion = 2;

//   DataRemoteSettings remoteSettings = 10;
//   BatteryStatus batteryStatus = 11;
//   CameraAndFlashlightState cameraAndFlashlightState = 12;
//   MotionDetectorState motionDetectorState = 13;
//   // app specific
//   LullabyPlayerState lullabyPlayerState = 40;
// }
